export const formatExpiryDate = (value = '') => {

  // remove trailing backslash if user pressing backspace
  if (value.length === 3 && value.endsWith('/')) {
    return value.substring(0, 2)
  }

  const expiryDate = value.split('/').join('').substring(0, 4)
  const numberOfSubstrings = Math.ceil(expiryDate.length / 2)
  const substrings = []

  Array.from({ length: numberOfSubstrings }, (_, i) => i).forEach(i => {
    substrings.push(expiryDate.substring(i * 2, i * 2 + 2))
  })

  // add trailing backslash if user finished typing second number
  if (expiryDate.length === 2) {
    substrings.push('')
  }

  return substrings.slice(0, 2).join('/')
}